<div class="assessment-container" [class.program-mode]="programsMode">
  <ng-container *ngIf="!assessmentSettings">
    <div class="container-area flex-row-container">
      <img matPrefix class="no-assessment-img" src="assets/img/assessment-radar-chart.png">
      <div class="no-assessment">
        <div class="no-assessment-title">Test Out the New AI Assessment!</div>
        <div class="no-assessment-text">
          <p>
            The Wonda AI Assessment Wizard allows you to leverage the power of GenAI to evaluate learners' performance on any given simulation based on your own specific assessment criteria.
          </p>
          <ol>
            <li>Tweak an existing rubric from a bank of expert-reviewed templates or create your own.</li>
            <li>Generate reports on your trainees’ latest sessions for review.</li>
            <li>Review and download the reports.</li>
          </ol>
          <p><em>Please note that this feature is in beta. Thanks for sharing your feedback.</em></p>    
        </div>
        <button mat-raised-button color="primary" (click)="editAssessment()">
          <mat-icon>edit</mat-icon>
          <span>CREATE A NEW ASSESSMENT</span>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!!assessmentSettings">
    <div *ngIf="!programsMode" class="container-area flex-column-container">
      <div class="flex-row-container">
        <div class="assessment-title-container">
          <div class="assessment-title">{{ assessmentSettings?.title }}</div>
          <mat-icon class="documentation-icon" (click)="openHelp()">help</mat-icon>
        </div>

        <div class="button-group">
          <!--The id is used by intercom to open the feedback window when the button is clicked.-->
          <button id="assessment-feedback-button" mat-button color="primary">
            <span>SEND FEEDBACK</span>
          </button>
          <button mat-raised-button color="primary" (click)="editAssessment()">
            <img width="16px" class="edit-assessment-icon" src='/assets/svg/assessment.svg'>
            <span>EDIT ASSESSMENT</span>
          </button>
        </div>
      </div>
      <div class="assessment-info-parent">
        <div class="assessment-info-column">
          <div class="assessment-info-title">Assessment Criteria</div>
          <div class="assessment-info-list">
            <ng-container *ngFor="let criteria of criteriaArray">
              <div class="assessment-info-item">
                <b class="criteria-index">{{ criteria[0] + 1 }} -</b>
                <span>{{ criteria[1].title }}</span>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="assessment-info-column">
          <div class="assessment-info-title">Chart Legend</div>
          <div class="assessment-info-list">
            <div class="assessment-info-item">
              <span class="legend-indicator legend-indicator-blue"></span>
              <span>Individual’s score</span>
            </div>
            <div class="assessment-info-item">
              <span class="legend-indicator legend-indicator-gray"></span>
              <span>Group median</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="button-group">
      <!-- Buttons group for Programs -->
      <ng-container *ngIf="programsMode && hasAssessments()">
        <user-search (searchChange)="searchUser($event)"></user-search>
        <button mat-button (click)="exportAssessments()" matTooltip="Export all reports">
          <mat-icon>download</mat-icon>
          <span>EXPORT REPORTS</span>
        </button>
        <button mat-raised-button color="primary" (click)="confirmAssessmentsRegeneration()">
          <span> REGENERATE REPORTS </span>
        </button>
      </ng-container>
      <!-- Buttons group for Spaces -->
      <ng-container *ngIf="!programsMode">
        <button mat-raised-button color="primary" (click)="confirmAssessmentsRegeneration()" [disabled]="!hasSessions()"
          [matTooltip]="hasSessions() ? '' : 'Launch your ' + (course.experience_type | courseLabel) + ' at least once to generate reports'"
          matTooltipClass="single-line-tooltip">
          <span> {{ hasAssessments() ? 'REGENERATE REPORTS' : 'GENERATE REPORTS' }} </span>
        </button>
        <button mat-button (click)="exportAssessments()" [disabled]="!hasAssessments()"
          [matTooltip]="hasAssessments() ? 'Export all reports' : 'Generate some reports to enable export'">
          <mat-icon>download</mat-icon>
          <span>EXPORT</span>
        </button>
        <mat-slide-toggle *ngIf="course.experience_type !== 'ai'" [checked]="assessmentSettings.learnerReportEnabled"
          (change)="toggleLearnerReport()" matTooltip="When ending their conversation, learners can generate their reports"
          matTooltipClass="single-line-tooltip">
          Allow learners to view their own report
        </mat-slide-toggle>
        <div class="last-reports-generated" *ngIf="hasAssessments()"> Last reports generated: {{ assessments[0].createdAt |
          date:'medium' }} </div>
      </ng-container>
    </div>

    <ng-container *loading="loadStatus">
      <ng-container *ngIf="!hasAssessments()">
        <div class="reports-max" *ngIf="!programsMode && hasSessions()">20 reports max.</div>
        <div class="generate-cta-wrapper" *ngIf="!assessments || assessments.length === 0">
          <div class="generate-cta">{{ programsMode ? "Reports will appear here once a session is completed or your simulation link is used" : "Click on “Generate Reports” above to generate your first reports" }}</div>
        </div>
      </ng-container>

      <ng-container *ngIf="hasAssessments()">
        <div class="assessments-grid">
          <ng-container *ngFor="let assessment of assessments">
            <assessment-card [assessment]="assessment" (showAssessment)="showAssessment($event)"></assessment-card>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
